import React from "react";
import { FaFilter, FaSearch } from "react-icons/fa";

const AttendanceFilters = ({
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  sortBy,
  setSortBy,
  totalResults,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 text-slate-800 dark:text-slate-100">
        <FaFilter className="text-sky-600 dark:text-sky-400" />
        <h2 className="text-lg font-semibold">Recherche & filtres clubs</h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-3">
        <div className="lg:col-span-5">
          <label className="text-sm font-medium text-slate-700 dark:text-slate-200">
            Recherche
          </label>
          <div className="mt-1 relative">
            <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Nom du club..."
              className="w-full rounded-2xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 px-10 py-3 text-sm outline-none focus:ring-2 focus:ring-sky-500/30"
            />
          </div>
        </div>

        <div className="lg:col-span-3">
          <label className="text-sm font-medium text-slate-700 dark:text-slate-200">
            Statut activité
          </label>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="mt-1 w-full rounded-2xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-sky-500/30"
          >
            <option value="all">Tous</option>
            <option value="recent">Très actifs</option>
            <option value="watch">À surveiller</option>
            <option value="inactive">Inactifs</option>
            <option value="none">Jamais utilisés</option>
          </select>
        </div>

        <div className="lg:col-span-2">
          <label className="text-sm font-medium text-slate-700 dark:text-slate-200">
            Trier par
          </label>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="mt-1 w-full rounded-2xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-sky-500/30"
          >
            <option value="recent">Plus récents</option>
            <option value="oldest">Plus anciens</option>
            <option value="calls_desc">Nb d'appels</option>
            <option value="groups_desc">Nb de groupes</option>
            <option value="name">Nom du club</option>
          </select>
        </div>

        <div className="lg:col-span-2 flex items-end">
          <div className="text-sm text-slate-500 dark:text-slate-400">
            {totalResults} club{totalResults > 1 ? "s" : ""}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceFilters;